export default __webpack_public_path__ + "static/media/gamedevelopers.bc0d727f.png";